import { useQuery } from '@apollo/client';
import { Box, makeStyles } from '@material-ui/core';
import { AccountCircleOutlined } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { RootState, useAppSelector } from 'redux/store';
import { statusSearch } from 'redux/style';
import { PATH } from 'routes/constant';
import { ReactComponent as Bag } from '../../assets/svg/Bag.svg';
import { ReactComponent as BagActive } from '../../assets/svg/bag_active.svg';
import { ReactComponent as Bell } from '../../assets/svg/BellSimple.svg';
import { ReactComponent as BellActive } from '../../assets/svg/bell_active.svg';
import { ReactComponent as AmiraIconActive } from '../../assets/svg/amira_icon_active.svg';
import AmiraIconInActive from '../../assets/img/amira_inactive.png';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
// import { ReactComponent as Hanger } from '../../assets/svg/hanger.svg';
// import { ReactComponent as HangerActive } from '../../assets/svg/hanger_active.svg';
import { ReactComponent as House } from '../../assets/svg/House.svg';
import { ReactComponent as HouseInActive } from '../../assets/svg/house_inactive.svg';
import { ReactComponent as UserActive } from '../../assets/svg/user_active.svg';
import { GET_NOTIFICATION } from '../../graph_ql/communication/notification/queries';
import { NotificationIcon } from './NotificationIcon';
import clsx from 'clsx';
import { setIsEffect } from 'redux/cart/cart.slice';
import { useAuth } from 'contexts/AuthContext';
import { colorPrimary } from 'constants/themes';
import utils from 'utils/utils';
import config from '../../config';
const useStyles = makeStyles((theme) => ({
    navigation: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        left: 0,
        maxWidth: 1024,
        right: 0,
        background: colorPrimary,
        padding: '0 32px',
        margin: 'auto',
        height: '56px',
        minHeight: 56,
        borderTop: '1px solid rgb(204 204 204 / 20%)',
        '@media (max-width: 1024px)': {
            position: 'fixed',
        },
        zIndex: 1,
        // boxShadow: '0px -1px 0px rgba(74, 108, 114, 0.5)'
    },
    navItem: {
        cursor: 'pointer',
    },
    amiraActive: {
        marginBottom: 2,
        maxWidth: 50,
    },
    amiraInactive: {
        marginBottom: 2,
    },
    notifyBag: {
        position: 'absolute',
        backgroundColor: 'red',
        fontSize: '9px',
        borderRadius: '50%',
        top: '0px',
        right: '-1px',
        height: 14,
        width: 14,
        minWidth: '14px',
        // padding: '1px 2px',
        // textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // verticalAlign: 'middle',
        // lineHeight: '12px',

        // animationIterationCount: 'infinite'
    },
    animationBag: {
        animation: `$myEffect 1000ms ${theme.transitions.easing.easeInOut}`,
        // animationIterationCount: 'infinite'
    },

    '@keyframes myEffect': {
        '0%': {
            height: 14,
            width: 14,
        },
        '50%': {
            height: 18.5,
            width: 18.5,
        },
        '100%': {
            height: 14,
            width: 14,
        },
    },
    iconBag: {
        color: 'white',
        width: 24,
        height: 24,

        // animationIterationCount: 'infinite',
        position: 'absolute',
        bottom: 3,
        left: 1,
    },
    amiraIconShadow: {
        boxShadow: '0px 0px 12px #F2D4BD',
        borderRadius: '16px',
    },
    animationTotal: {
        animation: `$iconEffect 1000ms ${theme.transitions.easing.easeInOut}`,
        // animationIterationCount: 'infinite'
    },
    '@keyframes iconEffect': {
        '0%': {
            height: 24,
            width: 24,
        },
        '50%': {
            width: 30,
            height: 30,
            bottom: '0px',
            left: '0px',
        },
        '100%': {
            height: 24,
            width: 24,
        },
    },
}));

function NavigationBottom(props) {
    const { currentUser } = useAuth();
    const classes = useStyles();
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();
    const listItem = useAppSelector((state) => state.cart?.order?.items || []);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const totalItem = listItem.reduce((pre, it) => pre + (it?.quantity || 0), 0);
    const { loading, data: notificationData } = useQuery(GET_NOTIFICATION, {
        variables: {
            paging: {
                size: 10,
                page: 0,
            },
        },
        context: {
            clientName: 'notification',
        },
        skip: !currentUser,
        fetchPolicy: 'cache-only',
    });
    const isEffectCart = useSelector((state: RootState) => state.cart.isEffect);
    const [isEffectIcon, setIsEffectIcon] = useState(isEffectCart || false);
    useEffect(() => {
        if (isEffectCart) {
            setIsEffectIcon(isEffectCart);
        }
        const timer = setTimeout(() => {
            setIsEffectIcon(false);
            dispatch(setIsEffect(false));
        }, 1000);
        return () => {
            clearTimeout(timer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEffectCart]);

    const handleNavigate = (link: String) => {
        history.push(`${link}`);
    };

    return (
        <Box id="bottom-nav" className={classes.navigation} px={3}>
            <Box
                display={'flex'}
                height={56}
                alignItems={'center'}
                justifyContent={'space-between'}
                // style={{ borderTop: "1px solid rgb(204 204 204 / 50%)" }}
            >
                <div>
                    <span className={classes.navItem} onClick={() => handleNavigate(PATH.HOME)}>
                        {location.pathname === '/home' ? (
                            <House style={{ color: 'white' }} />
                        ) : (
                            <HouseInActive style={{ color: 'white' }} />
                        )}
                    </span>
                </div>
                <div>
                    <span className={classes.navItem} onClick={() => handleNavigate(PATH.NOTIFICATIONS)}>
                        {loading &&
                            (location.pathname === PATH.NOTIFICATIONS ? (
                                <BellActive style={{ color: 'white' }} />
                            ) : (
                                <Bell style={{ color: 'white' }} />
                            ))}
                        {!loading && <NotificationIcon data={notificationData} />}
                    </span>
                </div>
                {/* <div>
                    <span className={classes.navItem} onClick={() => {
                        history.push(PATH.FEED)
                        dispatch(statusSearch(false))
                    }}>
                        {(location.pathname === PATH.FEED || location.pathname === PATH.STYLE_DETAIL ? (<HangerActive style={{ color: 'white' }} />) : (<Hanger style={{ color: 'white' }} />))}
                    </span>
                </div> */}
                <div
                    className={location.pathname === PATH.STYLE_ASSISTANT ? classes.amiraActive : classes.amiraInactive}
                >
                    <span
                        className={classes.navItem}
                        onClick={() => {
                            history.push(PATH.STYLE_ASSISTANT);
                        }}
                    >
                        {location.pathname === PATH.STYLE_ASSISTANT ? (
                            <AmiraIconActive width={85} style={{ width: 85, height: 90, marginLeft: -17 }} />
                        ) : (
                            <img alt="amiraIcon" src={AmiraIconInActive} width={50} style={{ width: 50, height: 50 }} />
                        )}
                    </span>
                </div>
                {/* </Badge> */}
                {!utils.isAppInWidgetMode() && !config.removeCheckOut && (
                    <div style={{ position: 'relative', width: 30, height: 30 }}>
                        <span
                            className={classes.navItem}
                            style={{ color: 'white' }}
                            onClick={() => handleNavigate(PATH.CART)}
                        >
                            {location.pathname === PATH.CART || location.pathname === PATH.CHECKOUT ? (
                                <BagActive
                                    className={clsx(classes.iconBag, {
                                        [classes.animationTotal]: isEffectIcon,
                                    })}
                                />
                            ) : (
                                <Bag
                                    className={clsx(classes.iconBag, {
                                        [classes.animationTotal]: isEffectIcon,
                                    })}
                                />
                            )}
                            {listItem && totalItem > 0 && (
                                <div
                                    className={clsx(classes.notifyBag, {
                                        [classes.animationBag]: isEffectIcon,
                                    })}
                                >
                                    {totalItem < 100 ? totalItem : '99+'}
                                </div>
                            )}
                        </span>
                    </div>
                )}
                <div>
                    <span
                        className={classes.navItem}
                        onClick={() => {
                            history.push(PATH.USER_LIKES);
                            dispatch(statusSearch(false));
                        }}
                    >
                        {location.pathname === PATH.USER_LIKES ? (
                            <FavoriteIcon style={{ color: 'white' }} />
                        ) : (
                            <FavoriteBorderOutlinedIcon style={{ color: 'white' }} />
                        )}
                    </span>
                </div>
                <div>
                    <span className={classes.navItem} onClick={() => handleNavigate(PATH.PROFILE)}>
                        {location.pathname === PATH.PROFILE || location.pathname === PATH.PROFILE_INFO ? (
                            <UserActive style={{ color: 'white' }} />
                        ) : (
                            <span style={{ color: 'white', position: 'relative' }}>
                                <AccountCircleOutlined />
                            </span>
                        )}
                    </span>
                </div>
            </Box>
        </Box>
    );
}

export default NavigationBottom;
